// src/pages/Login.tsx

/** @jsx createElement */
import { createElement } from "@mitosis/frontend-base";
import { links } from "../../../constants.ts";

const randomString = () =>
  Array.from({ length: 64 }, () => Math.random().toString(36)[2] || "0").join(
    "",
  );

document.addEventListener("DOMContentLoaded", () => {
  try {
    const clientId = "a4b6887b-57a0-492c-977e-07252622f7e4";
    const state = randomString();
    const nonce = randomString();

    const adLogin = `https://fs.test.lab/adfs/oauth2/authorize/?` +
      `client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${
        encodeURIComponent("https://navik-sso.otokoda.com/auth/login/ad/")
      }` +
      `&scope=${encodeURIComponent("openid profile email offline_access")}` +
      `&state=${encodeURIComponent(state)}` +
      `&nonce=${encodeURIComponent(nonce)}`;

    document.body.appendChild(
      <main>
        <h1>Navik medincus</h1>
        <div class="buttons-container">
          <a href={adLogin}>
            <button class="ad-login">Zaloguj się firmowo</button>
          </a>
          <a href={links.emailLogin()}>
            <button class="email-login">Zaloguj się funkcyjnie</button>
          </a>
        </div>
      </main>,
    );
  } catch (error) {
    console.error("Failed to initialize page:", error);
  }
});
